/**
 * This file was auto-generated from the openapi generate script.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars, @stylistic/max-len */

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../auth/auth.service';
import EnvService from '../../app.env';
import type { components } from './business';

export type UntaggedBaggagesDeleteVars = { baggageId: string };
export type UntaggedBaggagesReadVars = { baggageId: string };
export type UntaggedBaggagesUpdateVars = { baggageId: string };
export type TaglessBaggagesReadVars = { baggageId: string };
export type UntaggedBaggagesCreateReadVars = { createId: string };
export type UntaggedBaggagesSearchReadVars = { searchId: string };
export type UntaggedBaggagesSearchUpdateVars = { searchId: string };
export type TaggedBaggagesReadVars = { baggageId: string };
export type TaggedBaggagesSearchReadVars = { searchId: string };
export type TaggedBaggagesSearchUpdateVars = { searchId: string };
export type TaglessBaggagesSearchReadVars = { searchId: string };
export type TaglessBaggagesSearchUpdateVars = { searchId: string };

export type UntaggedBaggagesSearchQuery = { refOhd?: string, deviceId?: string, pageSize?: string, page: string, operatorHandled?: string };
export type TaggedBaggagesSearchGuiQuery = { pageSize?: string, page: string, q?: string, ids?: string };
export type TaggedBaggagesSearchQuery = { tag9Char?: string, passengerNameRecord?: string, paxFrequentTravelNumber?: string, flightDate?: string };

export type UntaggedBaggagesSearchParameters = { refOhd?: string, deviceId?: string, pageSize?: string, page: string, operatorHandled?: string };
export type UntaggedBaggagesDeleteParameters = { baggageId: string };
export type UntaggedBaggagesReadParameters = { baggageId: string };
export type UntaggedBaggagesUpdateParameters = { baggageId: string };
export type TaglessBaggagesReadParameters = { baggageId: string };
export type UntaggedBaggagesCreateReadParameters = { createId: string };
export type UntaggedBaggagesSearchReadParameters = { searchId: string };
export type UntaggedBaggagesSearchUpdateParameters = { searchId: string };
export type TaggedBaggagesSearchGuiParameters = { pageSize?: string, page: string, q?: string, ids?: string };
export type TaggedBaggagesReadParameters = { baggageId: string };
export type TaggedBaggagesSearchParameters = { tag9Char?: string, passengerNameRecord?: string, paxFrequentTravelNumber?: string, flightDate?: string };
export type TaggedBaggagesSearchReadParameters = { searchId: string };
export type TaggedBaggagesSearchUpdateParameters = { searchId: string };
export type TaglessBaggagesSearchReadParameters = { searchId: string };
export type TaglessBaggagesSearchUpdateParameters = { searchId: string };

export const UNTAGGED_BAGGAGES_SEARCH_TYPE = ['inventory', 'search'] as const;
export const UNTAGGED_BAGGAGES_SCOPES = ['NotFound', 'Found', 'Cancel', 'None'] as const;
export const CAMERA = ['FRONT_CAMERA', 'LEFT_CAMERA', 'RIGHT_CAMERA', 'REAR_CAMERA', 'TOP_CAMERA'] as const;
export const CAMERA_POSITION = ['FRONT-VIEW-1', 'FRONT-VIEW-2', 'FRONT-VIEW-3', 'FRONT-VIEW-4', 'BACK-VIEW-1', 'BACK-VIEW-2', 'BACK-VIEW-3', 'BACK-VIEW-4'] as const;
export const SHOOTING = ['FRONT_CAMERA', 'LEFT_CAMERA', 'RIGHT_CAMERA', 'REAR_CAMERA', 'TOP_CAMERA'] as const;
export const TRANSACTION_STATUS = ['IN_PROGRESS', 'DONE', 'ERROR', 'VOID'] as const;
export const CONFIDENCE = ['Low', 'High'] as const;
export const CLAIM_RELATION = ['TAG', 'PASSENGER_NAME_RECORD', 'FREQUENT_FLYER_NUMBER'] as const;
export const UNTAGGED_BAGGAGE_SEARCH_CREATE_RESULT_RELATION = ['TAG', 'PASSENGER_NAME_RECORD', 'FREQUENT_FLYER_NUMBER'] as const;
export const OPERATOR_DECISION = ['FOUND_WITH_MATCH', 'FOUND_WITHOUT_MATCH', 'NOT_FOUND'] as const;

export type UntaggedBaggagesSearchType = components['schemas']['UntaggedBaggagesSearchType'];
export type UntaggedBaggagesScopes = components['schemas']['UntaggedBaggagesScopes'];
export type Camera = components['schemas']['Camera'];
export type CameraPosition = components['schemas']['CameraPosition'];
export type imagesDictionary = components['schemas']['imagesDictionary'];
export type Device = components['schemas']['Device'];
export type TaggedBaggagesSearchResponse = components['schemas']['TaggedBaggagesSearchResponse'];
export type TaggedBaggagesSearchGuiResponse = components['schemas']['TaggedBaggagesSearchGuiResponse'];
export type TaggedBaggageResponse = components['schemas']['TaggedBaggageResponse'];
export type TaggedBaggage = components['schemas']['TaggedBaggage'];
export type ImagesSets = components['schemas']['ImagesSets'];
export type Shooting = components['schemas']['Shooting'];
export type ImagesSet = components['schemas']['ImagesSet'];
export type Photos = components['schemas']['Photos'];
export type Photo = components['schemas']['Photo'];
export type FlightSegment = components['schemas']['FlightSegment'];
export type FlightSegments = components['schemas']['FlightSegments'];
export type TaggedBaggagesSearchCreateBody = components['schemas']['TaggedBaggagesSearchCreateBody'];
export type SearchCreateResponse = components['schemas']['SearchCreateResponse'];
export type TaggedBaggagesSearchReadResponse = components['schemas']['TaggedBaggagesSearchReadResponse'];
export type TransactionStatus = components['schemas']['TransactionStatus'];
export type SearchMatchValue = components['schemas']['SearchMatchValue'];
export type Confidence = components['schemas']['Confidence'];
export type TaggedBaggagesSearchUpdateBody = components['schemas']['TaggedBaggagesSearchUpdateBody'];
export type TaglessBaggagesSearchUpdateBody = components['schemas']['TaglessBaggagesSearchUpdateBody'];
export type UntaggedBaggagesSearchUpdate = components['schemas']['UntaggedBaggagesSearchUpdate'];
export type UntaggedBaggagesUpdateBody = components['schemas']['UntaggedBaggagesUpdateBody'];
export type RealItineraryDateRange = components['schemas']['RealItineraryDateRange'];
export type UntaggedBaggagesSearchReadResponse = components['schemas']['UntaggedBaggagesSearchReadResponse'];
export type ClaimRelation = components['schemas']['ClaimRelation'];
export type MatchingDetails = components['schemas']['MatchingDetails'];
export type AlixResponse = components['schemas']['AlixResponse'];
export type ErrorResponse = components['schemas']['ErrorResponse'];
export type CrossingPoint = components['schemas']['CrossingPoint'];
export type AssociationImagesSetCrossingPoint = components['schemas']['AssociationImagesSetCrossingPoint'];
export type TaglessBaggage = components['schemas']['TaglessBaggage'];
export type UntaggedBaggage = components['schemas']['UntaggedBaggage'];
export type TaglessBaggageResponse = components['schemas']['TaglessBaggageResponse'];
export type UntaggedBaggageResponse = components['schemas']['UntaggedBaggageResponse'];
export type TaglessBaggagesResponse = components['schemas']['TaglessBaggagesResponse'];
export type UntaggedBaggagesResponse = components['schemas']['UntaggedBaggagesResponse'];
export type UntaggedBaggagesSearchResponse = components['schemas']['UntaggedBaggagesSearchResponse'];
export type TaglessBaggagesCreateBody = components['schemas']['TaglessBaggagesCreateBody'];
export type UntaggedBaggagesCreateBody = components['schemas']['UntaggedBaggagesCreateBody'];
export type TaglessBaggagesCreateResponse = components['schemas']['TaglessBaggagesCreateResponse'];
export type UntaggedBaggagesCreateResponse = components['schemas']['UntaggedBaggagesCreateResponse'];
export type TaglessBaggagesCreateReadResponse = components['schemas']['TaglessBaggagesCreateReadResponse'];
export type UntaggedBaggagesCreateReadResponse = components['schemas']['UntaggedBaggagesCreateReadResponse'];
export type UntaggedBaggagesSearchCreateBody = components['schemas']['UntaggedBaggagesSearchCreateBody'];
export type Claim = components['schemas']['Claim'];
export type UntaggedBaggageSearchCreateResultRelation = components['schemas']['UntaggedBaggageSearchCreateResultRelation'];
export type UntaggedBaggageSearchCreateNotifDone = components['schemas']['UntaggedBaggageSearchCreateNotifDone'];
export type UntaggedBaggageSearchCreateNotifError = components['schemas']['UntaggedBaggageSearchCreateNotifError'];
export type UntaggedBaggagesSearchResultRelatedTaggedBaggage = components['schemas']['UntaggedBaggagesSearchResultRelatedTaggedBaggage'];
export type UntaggedBaggagesSearchResultUntaggedBaggage = components['schemas']['UntaggedBaggagesSearchResultUntaggedBaggage'];
export type UntaggedBaggageSearchCreateTransactionValue = components['schemas']['UntaggedBaggageSearchCreateTransactionValue'];
export type OperatorDecision = components['schemas']['OperatorDecision'];
export type TaglessBaggagesSearchCreateBody = components['schemas']['TaglessBaggagesSearchCreateBody'];
export type SearchTaglessBaggagesMatchValue = components['schemas']['SearchTaglessBaggagesMatchValue'];
export type TaglessBaggagesSearchReadResponse = components['schemas']['TaglessBaggagesSearchReadResponse'];

@Injectable({
  providedIn: 'root',
})
export default class BusinessClient {
  private readonly domain: string;

  private readonly headers = () => new HttpHeaders({ Authorization: `Bearer ${this.authService.accessToken}` });

  private readonly httpClient = inject(HttpClient);

  private readonly env = inject(EnvService);

  private readonly authService = inject(AuthService);

  constructor() {
    this.domain = this.env.value('BUSINESS_CLIENT_DOMAIN');
  }

  /**
   * @description [GET] /alix: Return the Alix server infos
   */
  alixRead() {
    return this.httpClient.get<AlixResponse>(`${this.domain}/alix`, { headers: this.headers() });
  }

  /**
   * @description [GET] /untagged-baggages: Return a list of UntaggedBaggages matching given criterias
   */
  untaggedBaggagesSearch(query: UntaggedBaggagesSearchQuery) {
    return this.httpClient.get<UntaggedBaggagesSearchResponse>(`${this.domain}/untagged-baggages`, { params: query, headers: this.headers() });
  }

  /**
   * @description [POST] /untagged-baggages: Upload Untagged Baggages Images to backend
   */
  untaggedBaggagesCreate(body: UntaggedBaggagesCreateBody) {
    return this.httpClient.post<UntaggedBaggagesCreateResponse>(`${this.domain}/untagged-baggages`, body, { headers: this.headers() });
  }

  /**
   * @description [DELETE] /untagged-baggages/{baggageId}: Delete an Untagged baggage from its id
   */
  untaggedBaggagesDelete(vars: UntaggedBaggagesDeleteVars) {
    return this.httpClient.delete<unknown>(`${this.domain}/untagged-baggages/${vars.baggageId}`, { headers: this.headers() });
  }

  /**
   * @description [GET] /untagged-baggages/{baggageId}: Return the Untagged Baggage details from the its id
   */
  untaggedBaggagesRead(vars: UntaggedBaggagesReadVars) {
    return this.httpClient.get<UntaggedBaggageResponse>(`${this.domain}/untagged-baggages/${vars.baggageId}`, { headers: this.headers() });
  }

  /**
   * @description [PATCH] /untagged-baggages/{baggageId}: Update an UB by proving attributes
   */
  untaggedBaggagesUpdate(vars: UntaggedBaggagesUpdateVars, body: UntaggedBaggagesUpdateBody) {
    return this.httpClient.patch<UntaggedBaggageResponse>(`${this.domain}/untagged-baggages/${vars.baggageId}`, body, { headers: this.headers() });
  }

  /**
   * @description [GET] /tagless-baggages/{baggageId}: Return the Tagless Baggage details from the its id
   */
  taglessBaggagesRead(vars: TaglessBaggagesReadVars) {
    return this.httpClient.get<TaglessBaggageResponse>(`${this.domain}/tagless-baggages/${vars.baggageId}`, { headers: this.headers() });
  }

  /**
   * @description [GET] /untagged-baggages/create/{createId}: Return the create status and the Untagged Baggage details
   */
  untaggedBaggagesCreateRead(vars: UntaggedBaggagesCreateReadVars) {
    return this.httpClient.get<UntaggedBaggagesCreateReadResponse>(`${this.domain}/untagged-baggages/create/${vars.createId}`, { headers: this.headers() });
  }

  /**
   * @description [POST] /untagged-baggages/search: This resource is used to get the outcome of a cold search by providing elements related to a claim and some optional attributes.
   */
  untaggedBaggagesSearchCreate(body: UntaggedBaggagesSearchCreateBody) {
    return this.httpClient.post<SearchCreateResponse>(`${this.domain}/untagged-baggages/search`, body, { headers: this.headers() });
  }

  /**
   * @description [GET] /untagged-baggages/search/{searchId}: Return the search transaction details with its value if its state is DONE
   */
  untaggedBaggagesSearchRead(vars: UntaggedBaggagesSearchReadVars) {
    return this.httpClient.get<UntaggedBaggagesSearchReadResponse>(`${this.domain}/untagged-baggages/search/${vars.searchId}`, { headers: this.headers() });
  }

  /**
   * @description [PATCH] /untagged-baggages/search/{searchId}: Update an Untagged Baggage an return the updated object
   */
  untaggedBaggagesSearchUpdate(vars: UntaggedBaggagesSearchUpdateVars, body: UntaggedBaggagesSearchUpdate) {
    return this.httpClient.patch<unknown>(`${this.domain}/untagged-baggages/search/${vars.searchId}`, body, { headers: this.headers() });
  }

  /**
   * @description [GET] /tagged-baggages/search/by-criteria: Search tagged baggages by tag9Char or passengerNameRecord or paxFrequentTravelNumber or flightDate (flightDate cannot be alone)
   */
  taggedBaggagesSearchGui(query: TaggedBaggagesSearchGuiQuery) {
    return this.httpClient.get<TaggedBaggagesSearchGuiResponse>(`${this.domain}/tagged-baggages/search/by-criteria`, { params: query, headers: this.headers() });
  }

  /**
   * @description [GET] /tagged-baggages/{baggageId}: Return the Tagged Baggage details from the its id
   */
  taggedBaggagesRead(vars: TaggedBaggagesReadVars) {
    return this.httpClient.get<TaggedBaggageResponse>(`${this.domain}/tagged-baggages/${vars.baggageId}`, { headers: this.headers() });
  }

  /**
   * @description [POST] /tagged-baggages/search: Create a new asynchrone search in Tagged Baggages and return the search transaction details with its value if its state is DONE
   */
  taggedBaggagesSearchCreate(body: TaggedBaggagesSearchCreateBody) {
    return this.httpClient.post<SearchCreateResponse>(`${this.domain}/tagged-baggages/search`, body, { headers: this.headers() });
  }

  /**
   * @description [GET] /tagged-baggages/search: Search tagged baggages by tag9Char or passengerNameRecord or paxFrequentTravelNumber or flightDate (flightDate cannot be alone)
   */
  taggedBaggagesSearch(query: TaggedBaggagesSearchQuery) {
    return this.httpClient.get<TaggedBaggagesSearchResponse>(`${this.domain}/tagged-baggages/search`, { params: query, headers: this.headers() });
  }

  /**
   * @description [GET] /tagged-baggages/search/{searchId}: Return the search transaction details with its value if its state is DONE
   */
  taggedBaggagesSearchRead(vars: TaggedBaggagesSearchReadVars) {
    return this.httpClient.get<TaggedBaggagesSearchReadResponse>(`${this.domain}/tagged-baggages/search/${vars.searchId}`, { headers: this.headers() });
  }

  /**
   * @description [PATCH] /tagged-baggages/search/{searchId}: Update an Untagged Baggage an return the updated object
   */
  taggedBaggagesSearchUpdate(vars: TaggedBaggagesSearchUpdateVars, body: TaggedBaggagesSearchUpdateBody) {
    return this.httpClient.patch<unknown>(`${this.domain}/tagged-baggages/search/${vars.searchId}`, body, { headers: this.headers() });
  }

  /**
   * @description [POST] /tagless-baggages/search: Create a new asynchrone search in Tagless Baggages and return the search transaction details with its value if its state is DONE
   */
  taglessBaggagesSearchCreate(body: TaglessBaggagesSearchCreateBody) {
    return this.httpClient.post<SearchCreateResponse>(`${this.domain}/tagless-baggages/search`, body, { headers: this.headers() });
  }

  /**
   * @description [GET] /tagless-baggages/search/{searchId}: Return the search transaction details with its value if its state is DONE
   */
  taglessBaggagesSearchRead(vars: TaglessBaggagesSearchReadVars) {
    return this.httpClient.get<TaglessBaggagesSearchReadResponse>(`${this.domain}/tagless-baggages/search/${vars.searchId}`, { headers: this.headers() });
  }

  /**
   * @description [PATCH] /tagless-baggages/search/{searchId}: Provide a decision concerning a Tagless Baggage search
   */
  taglessBaggagesSearchUpdate(vars: TaglessBaggagesSearchUpdateVars, body: TaglessBaggagesSearchUpdateBody) {
    return this.httpClient.patch<unknown>(`${this.domain}/tagless-baggages/search/${vars.searchId}`, body, { headers: this.headers() });
  }
}
